module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "clientCurrentBalance"
  }, [_c('label', [_vm._v("баланс " + _vm._s(_vm.clientCurrentBalance))])]), _vm._v(" "), _c('div', {
    staticClass: "newAddMoney"
  }, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replenishBalanceSum),
      expression: "replenishBalanceSum"
    }],
    staticClass: "input sum",
    attrs: {
      "type": "number",
      "placeholder": "sum"
    },
    domProps: {
      "value": (_vm.replenishBalanceSum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.replenishBalanceSum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button is-info",
    attrs: {
      "disabled": !!_vm.loading
    },
    on: {
      "click": _vm.replenishBalance
    }
  }, [_vm._v("Пополнить")])])])]), _vm._v(" "), (_vm.addMoneyPage && _vm.addMoneyPage.content) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('label', {
    staticClass: "label addLabel"
  }, [_vm._v("Пополнения")]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered is-striped is-narrow campaignsTable"
  }, [_c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "sortButton",
    class: _vm.sortButtonClass('chargingTimestamp', 'asc'),
    on: {
      "click": function($event) {
        return _vm.changeSort('chargingTimestamp', 'asc')
      }
    }
  }, [_vm._v(_vm._s(_vm.ascIcon))]), _vm._v(" "), _c('div', {
    staticClass: "sortButton",
    class: _vm.sortButtonClass('chargingTimestamp', 'desc'),
    on: {
      "click": function($event) {
        return _vm.changeSort('chargingTimestamp', 'desc')
      }
    }
  }, [_vm._v(_vm._s(_vm.descIcon))]), _vm._v("\n          дата\n        ")]), _vm._v(" "), _c('th', [_c('div', {
    staticClass: "sortButton",
    class: _vm.sortButtonClass('sum', 'asc'),
    on: {
      "click": function($event) {
        return _vm.changeSort('sum', 'asc')
      }
    }
  }, [_vm._v(_vm._s(_vm.ascIcon))]), _vm._v(" "), _c('div', {
    staticClass: "sortButton",
    class: _vm.sortButtonClass('sum', 'desc'),
    on: {
      "click": function($event) {
        return _vm.changeSort('sum', 'desc')
      }
    }
  }, [_vm._v(_vm._s(_vm.descIcon))]), _vm._v("\n          сумма\n        ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.addMoneyPage.content), function(money, index) {
    return _c('tr', [_c('td', {
      staticClass: "date"
    }, [_vm._v("\n          " + _vm._s(_vm.getDateFormat(money.chargingTimestamp < 1000000000000 ? money.chargingTimestamp * 1000 : money.chargingTimestamp)) + "\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "sum"
    }, [_vm._v("\n          " + _vm._s(money.sum) + "\n        ")])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "paging-bottom"
  }, [_c('Paging', {
    attrs: {
      "refresh": _vm.loadAddMoneyData,
      "per-page": _vm.perPage,
      "data": _vm.addMoneyPage,
      "pagingClass": 'bottom'
    },
    on: {
      "update:data": function($event) {
        _vm.addMoneyPage = $event
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-515fb758"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/clientes/Balance.vue
// module id = 379
// module chunks = 42